import { z } from 'zod';
import { commissioningThresholdSourceBindingSchema } from './commissioning-threshold-state';

/** Structural capability is distinct from readiness of a period observation. */
export const commissioningThresholdBindingOptionsSchema = z.object({
  source: z.object({
    instanceId: z.string().uuid(), name: z.string(),
    competitionId: z.string().uuid(), competitionName: z.string(),
    scope: z.string(), axisLabel: z.string(), active: z.boolean(),
    competitionStatus: z.string(), publishedVersion: z.number().int().nonnegative(),
  }).strict(),
  consumerMemberCount: z.number().int().nonnegative(),
  options: z.array(z.object({
    binding: commissioningThresholdSourceBindingSchema,
    label: z.string(), compatible: z.boolean(), reason: z.string().nullable(),
    bands: z.array(z.object({
      id: z.string().uuid(), name: z.string(),
      memberCount: z.number().int().nonnegative(),
    }).strict()),
  }).strict()),
}).strict();
export type CommissioningThresholdBindingOptions = z.infer<typeof commissioningThresholdBindingOptionsSchema>;
